import { render, staticRenderFns } from "./ViewTx.vue?vue&type=template&id=19760dc4&scoped=true&"
import script from "./ViewTx.vue?vue&type=script&lang=js&"
export * from "./ViewTx.vue?vue&type=script&lang=js&"
import style0 from "./ViewTx.vue?vue&type=style&index=0&id=19760dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19760dc4",
  null
  
)

export default component.exports